export default __webpack_public_path__ + "static/media/1.040f04d7.jpg";